import React, { useState, useEffect } from "react";
import './classes/AgencySidebar.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Link from '@mui/material/Link';
import { configData } from "../config";
import { useLocation  } from 'react-router-dom';

const AgencySidebar = ({ updateToggle, drupal_uid, userLoggedInRoles}) => {
 
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
   
    const [options, setOptions] = useState([]);
   
    const app_url = configData.APP_URL;
   
    useEffect(() => {
      
     
      
    // Implement debouncing here if needed
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        // Replace with your actual API call
        const response = await fetch(app_url+'user/getagentathletelist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
  
  const renderOption = (props, option) => (
  <li {...props}>
    <Link href={option.link} color="inherit" underline="hover">
      {option.label}
    </Link>
  </li> 
);

const getOptionLabel = (option) => option.label;

const onChange = (event, newValue) => {
  if (newValue && newValue.link) {
    window.location.href = newValue.link;
  }
};

const location = useLocation();
const currentPath = location.pathname;

const hiddenPaths = [
  "/sports/", "/sports_agents_map", "/agents/"
];

const isHidden = hiddenPaths.some(path =>
  currentPath.includes(path)
);

    return(
      <div id="sidebar-third" className="grid_4">
        <div className="region region-sidebar-third">
            <div className="agent-block">
                <h2>Agent &amp; Athlete Search</h2>
                <div className="">
                    <p>
                        <Autocomplete
                          id="user_search"
                          disablePortal
                          options={options}
                          //  sx={{ width: 300 }}
                            sx={{ 
                                  width: "90%", 
                                  backgroundColor:"#fff",
                                  border: "1px solid #ccc",
                                  // maxHeight: "20px", 
                                  display: "inline-block"
                              }}
                          renderOption={renderOption}
                          getOptionLabel={getOptionLabel}
                          onChange={onChange}
                          renderInput={(params) => <TextField {...params} onChange={(event) => setSearchValue(event.target.value)}/>}
                        />
                    </p>

                </div>
            </div>
            {!isHidden && (
            <div className="agent-block">
                <h2>About SMWW Agency</h2>
                <div className="">
                    <div className="agent_bio_content">
                        <div style={{textAlign: "center"}}><img src="/basic/web/images/agency_logo.png" style={{width:"148px"}} /></div>
                        <div>
                            <h2 style={{padding: "0",border: "none"}}>SMWW Agency represents, promotes, manages, and markets elite athletes around the world.</h2>
                        </div>
                        <div style={{fontSize: "16px"}}>At SMWW, we’ve developed a trained network of Agents, Scouts, and Analysts who provide unique information on a player’s ability/character and insights into the needs and requirements of teams and clubs.</div>
                    </div>
                </div>
            </div>
            )}
        </div>
      </div>   
    );
};

export default AgencySidebar;